import { Session } from '../entity/entities';
import { PermissionsCatalogueEnum } from '../entity/enum/permissionsCatalogue';

/**
 * The caller's uClock permissions, read the same way on every uClock screen: an entry of
 * Session.userPermissions with Level 0 (visible). The server checks them too - this only keeps the
 * screens from offering what it would refuse.
 */
export class TlmPermissionHelper {
  public static has(permission: PermissionsCatalogueEnum): boolean {
    return !!(Session.userPermissions || []).find(
      (up: any) => up.FK_PermissionCatalogue == permission && up.Level == 0 /*visible*/
    );
  }

  /**
   * FENIKS US-9.2 (AC-6, AC-10): changing the location's setup - departments, jobs, house areas, department
   * managers and the schedule week - needs "uClock Setup" and "uClock Edit" (decision 2026-10-29), not
   * Manage Departments. Without them the Departments and Jobs tabs are read-only.
   */
  public static canChangeLocationSetup(): boolean {
    return (
      TlmPermissionHelper.has(PermissionsCatalogueEnum.TlmSetup) && TlmPermissionHelper.has(PermissionsCatalogueEnum.TlmEdit)
    );
  }

  /** "uClock Manage Departments": the caller sees every department of the location, not only their own. */
  public static seesAllDepartments(): boolean {
    return TlmPermissionHelper.has(PermissionsCatalogueEnum.TlmManageDepartments);
  }
}
